import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { CONFIG_ITEM_KEYS } from '../../../config-items/config-item-keys';
import { createEditorPluginAIConfigItemMarkdown } from '../../../config-items/config-items';
import { sliceOrNodeToMarkdown } from '../../../config-items/slice-or-node-to-markdown';
import { streamConvoAI } from '../../../provider/prompt-requests/convo-ai';
import { streamXPGenAI } from '../../../provider/prompt-requests/xp-gen-ai';
import { Icon } from '../../assets/icons/bbPrDescription';
import { createInsertAtCurrentPosition } from '../../config-item-actions/markdown';
import { messages } from './messages';
var SELECTION_TYPE = 'empty';
export var prDescriptionConfigItem = function prDescriptionConfigItem(options) {
  return createEditorPluginAIConfigItemMarkdown({
    key: CONFIG_ITEM_KEYS.CREATE_PULL_REQUEST_DESCRIPTION,
    title: messages.title,
    description: messages.description,
    selectionType: SELECTION_TYPE,
    icon: function icon(_ref) {
      var shownAt = _ref.shownAt;
      return /*#__PURE__*/React.createElement(Icon, {
        shownAt: shownAt
      });
    },
    getInitialContext: function getInitialContext(_ref2) {
      var editorView = _ref2.editorView,
        intl = _ref2.intl,
        updateIdMap = _ref2.updateIdMap,
        mentionMap = _ref2.mentionMap;
      var _sliceOrNodeToMarkdow = sliceOrNodeToMarkdown({
          node: editorView.state.doc,
          editorView: editorView,
          convertTo: 'markdown-plus',
          updateIdMap: updateIdMap,
          selectionType: SELECTION_TYPE,
          mentionMap: mentionMap
        }),
        markdown = _sliceOrNodeToMarkdow.markdown,
        contentStatistics = _sliceOrNodeToMarkdow.contentStatistics;
      return {
        document: markdown,
        userLocale: intl.locale,
        intentSchemaId: 'summarize_intent_schema.json',
        contentStatistics: contentStatistics
      };
    },
    triggerPromptRequest: function triggerPromptRequest(_ref3) {
      var initialContext = _ref3.initialContext,
        editorSchema = _ref3.editorSchema;
      if (fg('platform_editor_ai_assistance_service_pr_descrp_bb')) {
        return streamConvoAI({
          userLocale: initialContext.userLocale,
          intentSchemaId: 'bitbucket_pr_description_intent_schema.json',
          editorSchema: editorSchema,
          fullDocument: initialContext.document
        },
        // hook into replacement endpoint
        options.generativeAIApiUrl);
      }
      return streamXPGenAI({
        userLocale: initialContext.userLocale,
        intentSchemaId: 'summarize_intent_schema.json',
        editorSchema: editorSchema,
        contextList: [{
          type: 'ADF_MARKDOWN_V1',
          entity: initialContext.document,
          relationship: 'FULL_CONTENT'
        }]
      },
      // hook into replacement endpoint
      options.generativeAIApiUrl);
    },
    isVisible: function isVisible() {
      return true;
    },
    actions: [createInsertAtCurrentPosition({
      appearance: 'primary'
    })]
  });
};